import { Theme } from "@material-ui/core";
import { hexToRGB } from "src/util";

export const styles = (theme: Theme) => ({
  deleteSeasonButton: {
    "&:hover": {
      backgroundColor: `rgba(${hexToRGB(theme.palette.error.main)}, 0.75)`,
    },
    backgroundColor: theme.palette.error.main,
    color: theme.palette.background.paper,
  },
});



// WEBPACK FOOTER //
// ./src/pages/director/seasons/components/season-list/styles.ts